import template from './handies.html';
import controller from './handies.controller';
import './handies.scss';

let HandiesComponent = {
  bindings: {},
  template,
  controller
};

export default HandiesComponent;



// WEBPACK FOOTER //
// ./src/app/pages/handies/handies.component.js